import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

@Pipe({
    name: 'bypassSecurityTrustUrl',
    standalone: false
})
export class BypassSecurityTrustUrlPipe implements PipeTransform {


  constructor(private sanitizer: DomSanitizer) {
  }

  transform(url: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

}
